import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx, jsxs } from 'react/jsx-runtime';

var SvgBlockedUserPlaceholderXl = /*#__PURE__*/React.memo(function (props) {
  var theme = useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80"
  }, props), {}, {
    children: /*#__PURE__*/jsxs("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/jsx("circle", {
        cx: 40,
        cy: 40,
        r: 40,
        fill: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.themeMode.lightPalette.colorSet.white1000
      }), /*#__PURE__*/jsx("circle", {
        cx: 40,
        cy: 40,
        r: 40,
        fill: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.themeMode.lightPalette.colorSet.white1000
      }), /*#__PURE__*/jsx("circle", {
        cx: 40,
        cy: 40,
        r: 40,
        fill: props.iconColor ? props.iconColor : "#010505",
        fillOpacity: 0.38
      }), /*#__PURE__*/jsx("circle", {
        cx: 40,
        cy: 40,
        r: 36,
        fill: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.themeMode.lightPalette.colorSet.white1000
      }), /*#__PURE__*/jsx("path", {
        fill: props.iconColor ? props.iconColor : "#010505",
        fillOpacity: 0.38,
        d: "M50.076 46.015a12.7 12.7 0 0 0 4.098-9.358v-7.142c0-7.047-5.713-12.76-12.762-12.76h-2.824c-7.048 0-12.762 5.713-12.762 12.76v7.142a12.7 12.7 0 0 0 4.098 9.36c2.463 2.275 2.366 6.198-.24 8.307a10.4 10.4 0 0 1-3.01 1.698c-4.217 1.531-9.538 3.785-13.464 6.553a.884.884 0 0 0-.145 1.301C19.66 71.31 29.28 76 40 76s20.34-4.69 26.935-12.124a.884.884 0 0 0-.145-1.3c-3.926-2.769-9.247-5.023-13.465-6.554a10.4 10.4 0 0 1-3.008-1.697c-2.607-2.11-2.703-6.033-.241-8.31"
      }), /*#__PURE__*/jsx("circle", {
        cx: 56.3,
        cy: 54,
        r: 14,
        fill: "#9EA0A0"
      }), /*#__PURE__*/jsx("path", {
        fill: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.themeMode.lightPalette.colorSet.white1000,
        fillRule: "nonzero",
        d: "M56.3 39.5c8.008 0 14.5 6.492 14.5 14.5s-6.492 14.5-14.5 14.5S41.8 62.008 41.8 54s6.492-14.5 14.5-14.5m9.217 9.466-14.252 14.25A10.45 10.45 0 0 0 56.3 64.5c5.799 0 10.5-4.701 10.5-10.5 0-1.824-.465-3.54-1.283-5.034M56.3 43.5c-5.799 0-10.5 4.701-10.5 10.5 0 2.524.89 4.84 2.375 6.651L62.95 45.875A10.46 10.46 0 0 0 56.3 43.5"
      })]
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var SvgBlockedUserPlaceholderXl$1 = SvgBlockedUserPlaceholderXl;

export { SvgBlockedUserPlaceholderXl$1 as default };
